import map from 'lodash/map';
import without from 'lodash/without';
import matchAll from 'match-all';
import format from 'date-fns/format';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import isPast from 'date-fns/is_past';
import isFuture from 'date-fns/is_future';
import isToday from 'date-fns/is_today';
import isWithinRange from 'date-fns/is_within_range';
// import {
//   decodeGraphQLID,
// } from 'lib/relayUtils';

export const isInviteOnlyEvent = eventId => [1363, 1376, 1398].indexOf(+eventId) > -1;

const isMilestoneActive = (starts, ends) => isWithinRange(new Date(), starts, ends);

const isCommingSoon = event => isFuture(event.applicationStarts);

export const isApplicationMilestone = event => event.applicationStarts !== null
  && event.applicationEnds !== null
  && isMilestoneActive(event.applicationStarts, event.applicationEnds);

export const isBetweenApplicationAndSelectionMilestone = event => event.applicationEnds !== null
  && event.selectionStarts !== null
  && isMilestoneActive(event.applicationEnds, event.selectionStarts);

export const isBuildupMilestone = event => event.buildupStarts !== null
  && event.buildupEnds !== null
  && isMilestoneActive(event.buildupStarts, event.buildupEnds);

export const isExperienceMilestone = event => event.experienceStarts !== null
  && event.experienceEnds !== null
  && isMilestoneActive(event.experienceStarts, event.experienceEnds);

export const isNoticeMilestone = event => event.noticeStarts !== null
  && event.noticeEnds !== null
  && isMilestoneActive(event.noticeStarts, event.noticeEnds);

export const isNoticePast = event => event.noticeEnds !== null && isPast(event.noticeEnds);

export const isPartyMilestone = event => event.partyStarts !== null
  && event.partyEnds !== null
  && isMilestoneActive(event.partyStarts, event.partyEnds);

export const isPartyRangeMilestone = event => event.partyRangeStarts !== null
  && event.partyRangeEnds !== null
  && isMilestoneActive(event.partyRangeStarts, event.partyRangeEnds);

export const isPostTrialMilestone = event => event.postTrialStarts !== null
  && event.postTrialEnds !== null
  && isMilestoneActive(event.postTrialStarts, event.postTrialEnds);

export const isPreTrialMilestone = event => event.preTrialStarts !== null
  && event.preTrialEnds !== null
  && isMilestoneActive(event.preTrialStarts, event.preTrialEnds);

export const isBetweenApplicationAndPretrialMilestone = event => event.applicationEnds !== null
  && event.preTrialStarts !== null
  && isMilestoneActive(event.applicationEnds, event.preTrialStarts);

export const isBetweenApplicationAndNoticeMilestone = event => event.applicationEnds !== null
  && event.noticeStarts !== null
  && isMilestoneActive(event.applicationEnds, event.noticeStarts);

export const isReportingMilestone = event => event.reportingStarts !== null
  && event.reportingEnds !== null
  && isMilestoneActive(event.reportingStarts, event.reportingEnds);

export const isSelectionMilestone = event => event.selectionStarts !== null
  && event.selectionEnds !== null
  && isMilestoneActive(event.selectionStarts, event.selectionEnds);

export const getSelectionDate = event => {
  let sdate = null;
  if (event?.eventType === 'CHATTERBOX') {
    sdate = event.preTrialEndDate !== null && event.preTrialEndDate;
  } else {
    sdate = event?.selectionEndDate !== null && event?.selectionEndDate;
  }
  return sdate ? format(sdate, 'MMMM D') : sdate;
};

export const isTrialMilestone = event => event.trialStarts !== null
  && event.trialEnds !== null
  && isMilestoneActive(event.trialStarts, event.trialEnds);

export const isPastEvent = event => (event.chatterbox
    ? event.postTrialEnds !== null && isPast(event.postTrialEnds)
    : event.experienceEnds !== null && isPast(event.experienceEnds));

export const hasApplication = event => !!event.application;

export const isApplicationComplete = event => hasApplication(event) && event.application.complete;

export const isChatterbox = event => event.chatterbox;

export const isVirtual = event => event.virtual;

export const isParticipant = event => event.participant;

const isParticipantType = (event, type) => isParticipant(event) && includes(event.participation, type);

export const isPartyingNow = event => (isChatterbox(event) && isTrialMilestone(event))
  || (!isChatterbox(event)
    && isMilestoneActive(event.selectionStarts, event.partyRangeEnds));

export const isParticipantApplicant = event => isParticipantType(event, 'APPLICANT');

export const isParticipantChatterbox = event => isParticipantType(event, 'CHATTERBOX');

export const isParticipantGuest = event => isParticipantType(event, 'GUEST');

export const isParticipantHost = event => isParticipantType(event, 'HOST');

export const isApplicationFinalist = event => hasApplication(event)
  && event.application.finalist
  && !event.application.finalistInactive;

export const isApplicationFinalistDeactivated = event => hasApplication(event)
  && event.application.finalist
  && event.application.finalistInactive;

export const hasParty = event => !!event.hostingParty;

export const hasSetupParty = event => !isChatterbox(event) && hasParty(event) && event.hostingParty.setup;

export const hasNotSetupParty = event => !isChatterbox(event) && hasParty(event) && !event.hostingParty.setup;

export const canSetupParty = event => !isChatterbox(event)
  && ((isApplicationComplete(event)
    && isApplicationFinalist(event)
    && isSelectionMilestone(event))
    || hasNotSetupParty(event));

// event.acceptingApplicants && isApplicationPhase && !isCompleteApplicant
export const canApply = event => event.acceptingApplicants
  && isApplicationMilestone(event)
  && !hasParty(event)
  && !isApplicationComplete(event);

export const getCompletedInvitationCount = event => reduce(
    event.invitations,
    (completed, invitation) => {
      if (invitation.rsvp !== 'none') {
        return completed + 1;
      }
      return completed;
    },
    0,
  );

export const getIncompleteInvitationCount = event => reduce(
    event.invitations,
    (incomplete, invitation) => {
      if (invitation.rsvp === 'none') {
        return incomplete + 1;
      }
      return incomplete;
    },
    0,
  );

export const getCompletedActivityCount = event => reduce(
    event.activities,
    (completed, activity) => (!isEmpty(get(activity, 'activityResponse.completed'))
        ? completed + 1
        : completed),
    0,
  );

export const getIncompleteActivityCount = event => reduce(
    event.activities,
    (incomplete, activity) => {
      if (!activity.activityResponse || !activity.activityResponse.completed) {
        return incomplete + 1;
      }
      return incomplete;
    },
    0,
  );

export const getTotalActivityCount = event => event.activities.length;

export const getActivityProgress = event => {
  const completedActivities = getCompletedActivityCount(event);
  // start with actual event activities
  let totalActivities = getTotalActivityCount(event);
  if (!isChatterbox(event)) {
    // only houseparty events have invitations, so add any non-rsvp'd invites
    totalActivities += getIncompleteInvitationCount(event);
    if (canSetupParty(event)) {
      // if party setup is available, add this as an activity to do as well
      totalActivities += 1;
    }
  }
  if (completedActivities === 0) {
    return totalActivities === 0 ? 100 : 0;
  }
  return Math.min(
    // prevent values less than 0
    Math.max(
      // prevent values more than 100
      Math.round(Number(completedActivities / totalActivities) * 100),
      0,
    ),
    100,
  );
};

export const hasIncompleteInvitations = event => getIncompleteInvitationCount(event) > 0;

export const hasIncompleteActivities = event => getIncompleteActivityCount(event) > 0;

export const hasActivities = event => getTotalActivityCount(event) > 0;

export const getEventPartyDate = event => {
  // if (!event.chatterbox) {
  if (event.starts && event.ends) {
    let partyRangeString;
    if (
      format(event.starts, 'MMMM Do, YYYY')
      !== format(event.ends, 'MMMM Do, YYYY')
    ) {
      partyRangeString = `${format(event.starts, 'MMMM Do, YYYY')} - ${format(
        event.ends,
        'MMMM Do, YYYY',
      )}`;
    } else {
      partyRangeString = `${format(event.ends, 'MMMM Do, YYYY')}`;
    }
    if (isToday(event.starts) && isToday(event.ends)) {
      return 'Party Day is today';
    }
    if (isWithinRange(new Date(), event.starts, event.ends)) {
      return `Partying ${partyRangeString}`;
    }
    if (isPast(event.ends)) {
      return `Party was ${partyRangeString}`;
    }
    return `Party will be ${partyRangeString}`;
  }
  // }
  return null;
};

export const getEventPartyDateRange = event => {
  const { trialStarts, trialEnds, partyStarts, partyEnds } = event;
  const starts = event.chatterbox ? trialStarts : partyStarts;
  const ends = event.chatterbox ? trialEnds : partyEnds;
  if (starts && ends) {
    let partyRangeString;
    if (format(starts, 'MMMM D, YYYY') !== format(ends, 'MMMM D, YYYY')) {
      partyRangeString = `${format(starts, 'MMMM D, YYYY')} - ${format(
        ends,
        'MMMM D, YYYY',
      )}`;
    } else {
      partyRangeString = `${format(ends, 'MMMM D, YYYY')}`;
    }
    return partyRangeString;
  }
  return null;
};

export const getEventHashtags = event => {
  return event && event.hashtag
    ? without(
        map(matchAll(String(event.hashtag), /(#\w+)/gm).toArray(), match => match.replace('#', '').toLowerCase()),
        'sponsored',
      )
    : null;
};

export const getParticipantState = (event, onlyReportingPhase, defaults) => {
  const today = new Date();
  const isChatterboxAdvocate = isParticipantChatterbox(event);
  const isChatterboxEvent = isChatterbox(event);
  const isHost = isParticipantHost(event);
  const isApplicationPhase = isApplicationMilestone(event);
  const isBuildupPhase = isBuildupMilestone(event);
  const isExperiencePhase = isExperienceMilestone(event);
  const isNoticeInPast = isNoticePast(event);
  const isPostTrialPhase = isPostTrialMilestone(event);
  const isPreTrialPhase = isPreTrialMilestone(event);
  const isReportingPhase = isReportingMilestone(event);
  const isSelectionPhase = isSelectionMilestone(event);
  const isBetweenApplicationAndSelectionPhase = isBetweenApplicationAndSelectionMilestone(
    event,
  );
  const isTrialPhase = isTrialMilestone(event);
  const isPartySetup = hasSetupParty(event);
  const isPartyNotSetup = hasNotSetupParty(event);
  const isCompleteApplicant = hasApplication(event) && !hasParty(event) && isApplicationComplete(event);
  const isIncompleteApplicant = hasApplication(event) && !hasParty(event) && !isApplicationComplete(event);
  const isFinalist = isApplicationFinalist(event);
  const isDeactivatedFinalist = isApplicationFinalistDeactivated(event);
  const isEventCompleted = isPastEvent(event);

  if (isReportingPhase) {
    const noticeDisplay = format(event.noticeEnds, 'MMMM Do');
    if (isChatterboxEvent) {
      if ((!isNoticeInPast || isApplicationPhase) && isCompleteApplicant) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Good news! Your application is being considered. Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (
        isNoticeInPast
        && (isPreTrialPhase || isTrialPhase || isPostTrialPhase)
        && isChatterboxAdvocate
      ) {
        return {
          destination: {
            type: 'event-activities',
            data: event,
          },
          label:
            "You're a Chatterbox! Remember to complete your activities to remain in good standing for future opportunities.",
          showProgress: hasActivities(event),
          cta: false,
        };
      }
    }
    if (isFinalist) {
      if (
        (!isNoticeInPast
          || isApplicationPhase
          || !(
            isBetweenApplicationAndSelectionPhase
            || isSelectionPhase
            || isBuildupPhase
            || isExperiencePhase
          ))
        && isCompleteApplicant
      ) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Good news! Your application is being considered. Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (!isNoticeInPast && isBetweenApplicationAndSelectionPhase) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (
        isNoticeInPast
        && (isSelectionPhase || isBuildupPhase || isExperiencePhase)
      ) {
        return {
          destination: {
            type: 'party-setup',
            data: event,
          },
          label:
            'Secure your host spot. You need to invite guests in order to guarantee your spot before all the host spots are gone.',
          showProgress: hasActivities(event),
          cta: 'Setup Party',
        };
      }
    }
    if (isDeactivatedFinalist) {
      if (
        (!isNoticeInPast
          || isApplicationPhase
          || !(
            isBetweenApplicationAndSelectionPhase
            || isSelectionPhase
            || isBuildupPhase
            || isExperiencePhase
          ))
        && isCompleteApplicant
      ) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Good news! Your application is being considered. Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (!isNoticeInPast && isBetweenApplicationAndSelectionPhase) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (
        isNoticeInPast
        && (isSelectionPhase || isBuildupPhase || isExperiencePhase)
        && isCompleteApplicant
      ) {
        return {
          destination: { type: 'discover-events' },
          label:
            "Sorry, you didn't invite guests fast enough and host spots have filled. The good news is there's always another party! Follow us on Facebook and X to know as soon as event selection begins!",
          showProgress: false,
          cta: 'Discover Events',
        };
      }
    }
    if (isCompleteApplicant) {
      if (
        !isNoticeInPast
        || isApplicationPhase
        || !(
          isBetweenApplicationAndSelectionPhase
          || isPreTrialPhase
          || isSelectionPhase
          || isTrialPhase
          || isPostTrialPhase
          || isBuildupPhase
          || isExperiencePhase
        )
      ) {
        return {
          destination: {
            type: 'event-activities',
            data: event,
          },
          label: `Good news! Your application is being considered. Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: hasActivities(event),
          cta: false,
        };
      }
      if (!isNoticeInPast && isBetweenApplicationAndSelectionPhase) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (
        isNoticeInPast
        && (isPreTrialPhase
          || isSelectionPhase
          || isTrialPhase
          || isPostTrialPhase
          || isBuildupPhase
          || isExperiencePhase)
      ) {
        return {
          destination: { type: 'discover-events' },
          label:
            "Sorry, you weren't selected. We wish everyone could be selected, but sadly that's not possible. See what other events are happening that you might also be interested in.",
          showProgress: false,
          cta: 'Discover Events',
        };
      }
    }
    if (isIncompleteApplicant) {
      if (!isNoticeInPast || isApplicationPhase) {
        return {
          destination: {
            type: 'event-apply',
            data: event,
          },
          label:
            "Your application isn't finished! Don't miss a chance to be a part of this awesome event.",
          showProgress: false,
          cta: 'Finish Application',
        };
      }
      if (
        isNoticeInPast
        && (isPreTrialPhase
          || isSelectionPhase
          || isTrialPhase
          || isPostTrialPhase
          || isBuildupPhase
          || isExperiencePhase)
      ) {
        return {
          destination: { type: 'discover-events' },
          label: 'You did not complete an application to this event.',
          showProgress: false,
          cta: 'Discover Events',
        };
      }
    }
    if (isPartyNotSetup) {
      if (
        (!isNoticeInPast
          || isApplicationPhase
          || !(
            isBetweenApplicationAndSelectionPhase
            || isSelectionPhase
            || isBuildupPhase
            || isExperiencePhase
          ))
        && isCompleteApplicant
      ) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Good news! Your application is being considered. Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (!isNoticeInPast && isBetweenApplicationAndSelectionPhase) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (
        isNoticeInPast
        && (isSelectionPhase || isBuildupPhase || isExperiencePhase)
      ) {
        return {
          destination: {
            type: 'party-setup',
            data: event,
          },
          label:
            "Secure your host spot. We're reserving your spot. You need to invite guests in order to guarantee your spot before all the host spots are gone.",
          showProgress: hasActivities(event),
          cta: 'Setup Party',
        };
      }
    }
    if (isPartySetup) {
      if (
        (!isNoticeInPast
          || isApplicationPhase
          || !(
            isBetweenApplicationAndSelectionPhase
            || isSelectionPhase
            || isBuildupPhase
            || isExperiencePhase
          ))
        && isCompleteApplicant
      ) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Good news! Your application is being considered. Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (!isNoticeInPast && isBetweenApplicationAndSelectionPhase) {
        return {
          destination: {
            type: 'event-details',
            data: event,
          },
          label: `Be sure to check back on or around ${noticeDisplay} to find out if you've been selected.`,
          showProgress: false,
          cta: false,
        };
      }
      if (
        isHost
        && isNoticeInPast
        && (isSelectionPhase || isBuildupPhase || isExperiencePhase)
      ) {
        return {
          destination: {
            type: 'event-activities',
            data: event,
          },
          label:
            "You're a host! Remember to complete your activities to remain in good standing so you can host future House Parties.",
          showProgress: false,
          cta: false,
        };
      }
    }
  } else if (isNoticeInPast) {
    if (onlyReportingPhase) {
      return {
        destination: null,
        label: null,
        showProgress: false,
        cta: false,
      };
    }
    if (isIncompleteApplicant) {
      return {
        destination: {
          type: 'event-details',
          data: event,
        },
        label: 'You did not complete an application to this event.',
        showProgress: false,
        cta: false,
      };
    }
    if (isChatterboxAdvocate && isChatterboxEvent) {
      return {
        destination: {
          type: 'event-details',
          data: event,
        },
        label: 'You were a Chatterbox!',
        showProgress: false,
        cta: false,
      };
    }
    if (isHost && isEventCompleted) {
      return {
        destination: {
          type: 'event-details',
          data: event,
        },
        label: `You are ${isChatterboxEvent ? 'an advocate' : 'a host'}!`,
        showProgress: false,
        cta: false,
      };
    }
    if (isCompleteApplicant || isFinalist || isDeactivatedFinalist) {
      return {
        destination: {
          type: 'event-details',
          data: event,
        },
        label: "Sorry, you weren't selected.",
        showProgress: false,
        cta: false,
      };
    }
  }

  if (!onlyReportingPhase) {
    if (event.applicationStarts > today) {
      return {
        destination: null,
        label: 'Check back soon for this application!',
        showProgress: false,
        cta: false,
      };
    }
    if (
      event.acceptingApplicants
      && isApplicationPhase
      && !isCompleteApplicant
    ) {
      return {
        destination: {
          type: 'event-apply',
          data: event,
        },
        label: null,
        showProgress: false,
        cta: 'Apply Now',
      };
    }
    if (event.applicationStarts < today) {
      return {
        destination: null,
        label: 'The opportunity to complete the application has passed',
        showProgress: false,
        cta: false,
      };
    }
  }

  if (defaults && (isHost || isChatterboxAdvocate)) {
    return {
      destination: {
        type: 'event-details',
        data: event,
      },
      label: `You are ${isChatterboxEvent ? 'an advocate' : 'a host'}!`,
      showProgress: false,
      cta: false,
    };
  }

  return {
    destination: null,
    label: null,
    showProgress: false,
    cta: false,
  };
};

export const phases = {
  PRE_RECRUITMENT: 'PRE_RECRUITMENT',
  RECRUITMENT_APPLICATION: 'RECRUITMENT_APPLICATION',
  RECRUITMENT_NOTICE: 'RECRUITMENT_NOTICE',
  PRETRIAL_SELECTION: 'PRETRIAL_SELECTION',
  TRAIL_BUILDUP_PARTY: 'TRAIL_BUILDUP_PARTY',
  POSTTRAIL_EXPERIENCE: 'POSTTRAIL_EXPERIENCE',
  EVENT_END: 'EVENT_END',
};

export const getEventPhase = event => {
  const milestones = {
    comingSoon: isCommingSoon(event),
    application: isApplicationMilestone(event),
    notice:
      isNoticeMilestone(event)
      || isBetweenApplicationAndPretrialMilestone(event)
      || isBetweenApplicationAndNoticeMilestone(event),
    preTrail: isPreTrialMilestone(event),
    trail: isTrialMilestone(event),
    postTrail: isPostTrialMilestone(event),
    reporting: isReportingMilestone(event),
    selection:
      isSelectionMilestone(event)
      || isBetweenApplicationAndSelectionMilestone(event),
    buildup: isBuildupMilestone(event),
    party: isPartyMilestone(event),
    partyRange: isPartyMilestone(event),
    experience: isExperienceMilestone(event),
  };

  let phase = '';
  if (milestones.comingSoon) {
    phase = phases.PRE_RECRUITMENT;
  } else if (milestones.application) {
    phase = phases.RECRUITMENT_APPLICATION;
  } else if (milestones.notice) {
    phase = phases.RECRUITMENT_NOTICE;
  } else if (milestones.preTrail || milestones.selection) {
    phase = phases.PRETRIAL_SELECTION;
  } else if (
    milestones.buildup
    || milestones.party
    || milestones.partyRange
    || milestones.trail
  ) {
    phase = phases.TRAIL_BUILDUP_PARTY;
  } else if (milestones.postTrail || milestones.experience) {
    phase = phases.POSTTRAIL_EXPERIENCE;
  } else {
    phase = phases.EVENT_END;
  }

  return phase;
};

export const getEventMilestoneLabelWithDate = event => {
  const phase = getEventPhase(event);
  const chatterbox = isChatterbox(event);
  let label = '';
  let date = '';

  switch (phase) {
    case phases.PRE_RECRUITMENT:
      label = 'Applications open on';
      date = event.applicationStarts;
      break;
    case phases.RECRUITMENT_APPLICATION:
      label = 'Applications close on';
      date = event.applicationEnds;
      break;
    case phases.RECRUITMENT_NOTICE:
      label = 'Selections close on';
      date = chatterbox ? event.noticeEnds : event.selectionEnds;
      break;
    case phases.PRETRIAL_SELECTION:
      if (chatterbox) {
        label = 'Experiencing until';
        date = event.postTrialEnds;
      } else {
        label = 'Selections close on';
        date = event.selectionEnds;
      }
      break;
    case phases.TRAIL_BUILDUP_PARTY:
    case phases.POSTTRAIL_EXPERIENCE:
      label = 'Experiencing until';
      date = chatterbox
        ? event.postTrialEnds
        : event.experienceEnds || event.partyEnds;
      break;
    case phases.EVENT_END:
    default:
      label = 'This Event ended on';
      date = chatterbox
        ? event.postTrialEnds
        : event.experienceEnds || event.partyEnds;
      break;
  }

  return {
    label,
    date: format(date, 'MMMM D, YYYY'),
  };
};
